'use client'

import React from 'react'

import { CmdChip } from '@/components/ui'

export const Alerts = () => {
  const data = React.useMemo(
    () => [
      {
        notice:
          'Product prices has been updated in the system. Please refresh before placing new sales.',
        shortcut: '10',
      },
    ],
    [],
  )

  return (
    <div className="h-[var(--alerts-bar-height)]">
      <div className="flex h-full w-full items-center">
        {data.map(({ notice, shortcut }, index) => {
          return (
            <div
              key={index}
              className="flex h-full w-full items-center gap-2 bg-yellow-300 px-6"
            >
              <span className="text-sm font-normal">{notice}</span>
              <CmdChip variant="light" className="py-1 text-xs">
                {shortcut}
              </CmdChip>
            </div>
          )
        })}
      </div>
    </div>
  )
}
